import { ref, onMounted, onBeforeUnmount } from 'vue'

/**
 * Composable que monitorea la expiración del token JWT y
 * muestra un aviso 5 minutos antes de que expire la sesión.
 *
 * Uso en App.vue o MainLayout:
 *   const { sesionPorExpirar, minutosRestantes, renovarSesion } = useSessionWarning()
 */
export function useSessionWarning() {
  const sesionPorExpirar = ref(false)
  const minutosRestantes = ref(0)
  let timer = null

  const MINUTOS_AVISO = 5

  const decodificarToken = () => {
    try {
      const token = localStorage.getItem('dte_token')
      if (!token) return null

      const payload = token.split('.')[1]
      const decoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')))
      return decoded
    } catch {
      return null
    }
  }

  const verificar = () => {
    const payload = decodificarToken()
    if (!payload?.exp) {
      sesionPorExpirar.value = false
      return
    }

    const ahora = Math.floor(Date.now() / 1000)
    const restantesSeg = payload.exp - ahora
    const restantesMin = Math.floor(restantesSeg / 60)

    minutosRestantes.value = restantesMin

    if (restantesMin <= MINUTOS_AVISO && restantesMin > 0) {
      sesionPorExpirar.value = true
    } else if (restantesMin <= 0) {
      sesionPorExpirar.value = false
    } else {
      sesionPorExpirar.value = false
    }
  }

  const descartarAviso = () => {
    sesionPorExpirar.value = false
  }

  onMounted(() => {
    verificar()
    timer = setInterval(verificar, 30000) // Verificar cada 30s
  })

  onBeforeUnmount(() => {
    if (timer) clearInterval(timer)
  })

  return {
    sesionPorExpirar,
    minutosRestantes,
    descartarAviso
  }
}
